export function handleException(error) {   // eslint-disable-line no-unused-vars
	if(error.response) {
		// 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
		const originalUrl = error.response.request.responseURL || error.response.config.url;
		const error_url = new URL(originalUrl, `http://${process.env.VUE_APP_PLAN_API_BASE}`);
		
		if(error_url.pathname === '/study/plan/detail') {
			if(error.response.data.code === 'E0007') {
				//alert('적용된 합격계획표가 없습니다. 합격계획표를 만드시겠습니까?');
				window.parent.location.href = `${process.env.VUE_APP_EDUWILL_EVENT}/Event/2021/G/Modeling`;
			}
		}
		
	}else if(error.request) {
		// 요청이 이루어 졌으나 응답을 받지 못했습니다.
		// `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
		// Node.js의 http.ClientRequest 인스턴스입니다.
		console.log(error.request);
	}else {
		// 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
		console.log('Error', error.message);
	}

}
